import { useCallback } from 'react';
import { useParams } from 'react-router-dom';
import { loadPostCollectionAsync } from '../../data-layer/posts/actions';
import { BusinessPostStub } from '../../ui/business/BusinessPostStub/BusinessPostStub';
import { useIsMobile } from '../../utils/getIsMobile';
import { ymTrackPostKebabClick } from '../../utils/metrika';
import { usePostCollection } from '../post/usePostCollection';
import { useCurrentUser } from '../users/useCurrentUser';
import { useItemsWithoutAd } from '../utils/useItemsWithAd';
import { BusinessResizableGrid } from './BusinessResizableGrid/BusinessResizableGrid';
import { useBusinessModel } from './useBusinessModel';

const PER_PAGE = 24;

type Filters = Omit<Parameters<typeof loadPostCollectionAsync>[1], 'next'>;

export const makeBusinessPostsTab = (namespace: string, filters: Partial<Filters>) => () => {
    const params = useParams();
    const businessId = params.businessId!;
    const business = useBusinessModel({ businessId });
    const postCollection = usePostCollection({
        namespace: `${namespace}-${businessId}`,
        filters: {
            ...filters,
            businessId,
            amount: PER_PAGE,
        },
        forceFiltersUpdate: true,
    });
    const currentUser = useCurrentUser();

    const onPostKebabClick = useCallback(() => {
        ymTrackPostKebabClick({
            page: 'Профиль бизнеса',
            userLogin: currentUser?.login,
            businessId: currentUser?.profile?.publicId,
        });
    }, [currentUser?.login, currentUser?.profile?.publicId]);

    const itemsWithoutAds = useItemsWithoutAd({
        items: postCollection.items,
    });

    const isMobile = useIsMobile();

    if (isMobile === null) {
        return null;
    }

    if (!itemsWithoutAds.length && !postCollection.isLoading) {
        return <BusinessPostStub business={business} currentUser={currentUser} />;
    }

    return (
        <BusinessResizableGrid
            items={itemsWithoutAds}
            businessId={businessId}
            onLoadNext={postCollection.onLoadNext}
            user={currentUser}
            onPostKebabClick={onPostKebabClick}
            isService={business?.isService}
        />
    );
};
